export default __webpack_public_path__ + "static/media/darren.40ba709c.bin";